import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faCheck} from "@fortawesome/free-solid-svg-icons";
import {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";

function RecoverPasswordSuccess(){
    const [countDown, setCountDown] = useState(5);
    const navigate = useNavigate();

    useEffect(() => {
        if (countDown <= 0){
            navigate("/auth/signin", { replace: true });
            return;
        }

        const timer = setInterval(() => {
            setCountDown(prev => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [countDown]);

    return(
        <div className="px-xxl-5">
            <div className="text-center mb-6">
                <div className="mb-3">
                    <div>
                        <FontAwesomeIcon className="text-success fw-bold" icon={faCheck} />
                    </div>
                    <h4 className="mb-3 text-success">Password Changed Successfully</h4>
                    <p className="text-body-tertiary fs-8-1 mb-1">Your password has been updated. You can now log in
                        with your new password.</p>
                </div>
                <p className="fs-8-1">
                    You will be redirected to the login page in <span id="countdown">{countDown}</span> seconds.<br/>
                    If not, please click “Go to Login”.
                </p>
                <p>
                    <Link className="w-100 mb-3 fs-8-1 fw-bold " to="/auth/signin">
                        <FontAwesomeIcon className="me-2" icon={faChevronLeft}/>Go to Signin page
                    </Link>
                </p>
            </div>
        </div>
    )
}

export default RecoverPasswordSuccess;